import { render, staticRenderFns } from "./subscriptionseller.vue?vue&type=template&id=eff25522&scoped=true"
import script from "./subscriptionseller.vue?vue&type=script&lang=js"
export * from "./subscriptionseller.vue?vue&type=script&lang=js"
import style0 from "./subscriptionseller.vue?vue&type=style&index=0&id=eff25522&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff25522",
  null
  
)

export default component.exports